import { useCallback } from 'react';
import RemoveIcon from '@mui/icons-material/Remove';
import { Tooltip } from '@mui/material';
import IconButton from '@mui/material/IconButton';

import PropTypes from 'prop-types';

const MinimizeWindow = ({ minimizeHandler }) => {
    const handleClick = useCallback(
        (e) => {
            e.stopPropagation();
            minimizeHandler();
        },
        [minimizeHandler]
    );

    return (
        <Tooltip title="Minimize [Alt + ↓]">
            <IconButton sx={{ padding: '0.25rem' }} aria-label="minimize" onClick={handleClick}>
                <RemoveIcon sx={{ width: '1.5rem', height: '1.5rem', color: '#fff' }} />
            </IconButton>
        </Tooltip>
    );
};

MinimizeWindow.prpTypes = {
    minimizeHandler: PropTypes.func.isRequired,
};

export default MinimizeWindow;
